// =========================
// IN HERE WE GET ALL ADDON TOTALS. PRICE HANDLING WILL BE IN PRODUCT-TEMPLATE-GLOBAL-SCRIPTS.JS, updatePrice() function
/*
getCurrentPricing
updatePrice
updateInstallment
updateVoucher
*/
// =========================
function hasGroupsell() {
  return $(".groupsell-wrap").length > 0;
}

// =========================
// ADDON TOTAL
// =========================
function getAddonTotal() {

  let total = 0;

  if (hasGroupsell()) {

    // =========================
    // GROUPSELL TOTAL
    // =========================
    $(".groupsell-wrap input[type='radio']:checked").each(function () {

        const price = Number($(this).data("price")) || 0;

        total += price;

        /*
        console.log(
            "Groupsell:",
            $(this).attr("name"),
            price
        );*/

    });

  }
  // =========================
  // GROUPSELL TOP-UP
  // =========================
  $(".bundled-addon-selectors.selected").each(function () {

      const price =
          Number(
              $(this)
                  .find(".data-topup-price")
                  .data("topup-price")
          ) || 0;

      //console.log("Groupsell Topup:", price);

      total += price;

  });


  // =========================
  // ADDON BY VARIANTS
  // =========================
  let shouldRefreshPrice = false;

  $(".addon_by_variants-container .addon").each(function () {

      const $addon = $(this);

      // Hidden warranty -> reset it
      if ($addon.hasClass("hide")) {

          if ($addon.hasClass("selected-option")) {
              shouldRefreshPrice = true;
          }

          $addon
              .removeClass("selected-option");

          $addon
              .find("input")
              .prop("checked", false);

          return; // skip pricing

      }

      // Visible & selected warranty -> add price
      if ($addon.hasClass("selected-option")) {

          const price =
              Number($addon.find("input").data("price")) || 0;

          /*
          console.log(
              "Warranty found:",
              $addon,
              price
          );
          */

          total += price;

      }

  });

  // =========================
  // MONITOR ADDONS
  // =========================
  $(".addon-item input:checked").each(function () {

      const price = Number($(this).data("price")) || 0;

      //console.log("Monitor addon:", price);

      total += price;

  });

  // Recalculate once after cleanup
  if (shouldRefreshPrice) {
      setTimeout(() => {
          updateDynamicPrice();
      }, 0);
  }

  total += Number($("#currentSelection").attr("data-total-price") || 0);

  // =========================
  // LAUNDRY RACK ADDONS SUPPORT
  // ran the function in wr_bundle_selector.js on click of bundled-product / band-aid.js
  // =========================

  $(".bundled-products .bundled-product.selected").each(function () {

      const priceText = $(this)
          .find(".topup-price")
          .text()
          .trim();

      const price =
          Number(priceText.replace("$", "").replace(/,/g, "")) || 0;

      //console.log("Laundry bundle price:", price);

      total += price;

  });

    // =========================
    // SOLARIS ACCESSORIES
    // update data-price in liquid file solaris-accs-addon.liquid
    // =========================
    $(".solaris-accs-addon-container .addon-item").each(function () {

        const qty = parseInt(
            $(this).find('[name="addon-qty"]').val(),
            10
        ) || 0;

        if (qty === 0) return;

        const price = Number($(this).data("price")) || 0;

        total += qty * price;

        /*
        console.log(
            "Solaris:",
            qty,
            "x",
            price,
            "=",
            qty * price
        );
        */
    });

    // =========================
    // FAN EXTRA QUANTITY
    // =========================
    const extraQtyPrice =
        Number($("#currentSelection").attr("data-extra-qty-price")) || 0;

    if (extraQtyPrice > 0) {

        /*
        console.log(
            "Fan Extra Qty:",
            extraQtyPrice
        );
        */

        total += extraQtyPrice;
    }
    // =========================
    // AIR PURIFIER FILTER SUBSCRIPTION
    // =========================
    $(".ap-filter-sub-box-wrap .newsalebox2.selected").each(function () {

        const priceText = $(this)
            .find(".prodprice2 .newprice")
            .text()
            .trim();

        const price =
            Number(
                priceText
                    .replace("$", "")
                    .replace(/,/g, "")
            ) || 0;

        /*
        console.log(
            "AP Subscription:",
            price
        );
        */

        total += price;

    });



  //return total;
}

// =========================
// MAIN UPDATE
// =========================
function updateDynamicPrice() {

    //console.trace("updateDynamicPrice");
  const addonTotal = getAddonTotal();

  //console.log({addonTotal});

  $("#currentSelection")
      .attr("data-addon-total", addonTotal);

  if (typeof updatePrice === "function") {
      updatePrice();
    }
  updateInstallment();
  updateVoucher();
}

//======================================= CLICK AND FUNCTION HANDLERS
// =========================
// LIB
// =========================
function delayFix(fn) {
  setTimeout(fn, 100);
}

// =========================
// TOGGLEABLE RADIO BEHAVIOR
// =========================
if (hasGroupsell()) {
  delayFix(() => $(".click-plus, .click-plus-2").click(updateDynamicPrice));
}

// =========================
  // PRODUCT VARIANT CHANGE
  // =========================
  $(document).on(
    "click",
    ".variant-select .variant-item",
    function () {

      // wait for currentSelection/data-variant to update
      setTimeout(() => {

        if (typeof updateDynamicPrice === "function") {
          updateDynamicPrice();
        }

      }, 50);

    }
  );
  
//FOR MONITORS UPSELL
$(document).on("click", ".addon-item", function () {
  // wait for checkbox to toggle
  setTimeout(() => {
    updateDynamicPrice();
  }, 0);
});
// FOR WARRANTY ADD-ON BY VARIANTS CONTAINER
//transfer js file as well
$(document).on(
  "change",
  ".addon_by_variants-container .addon",
  function () {

    setTimeout(() => {
      updateDynamicPrice();
    }, 50);

  }
);

// ========================================
// LAUNDRY TOP-UP PRICE OBSERVER
// ========================================

(function () {

    const observer = new MutationObserver(function () {

        if (typeof updateDynamicPrice === "function") {
            updateDynamicPrice();
        }

    });

    function attachObserver() {

        const target = document.querySelector(
            ".washer_rack_bundle_selector .bundled-product.selected .topup-price"
        );

        if (!target) return;

        observer.disconnect();

        observer.observe(target, {
            childList: true,
            characterData: true,
            subtree: true
        });

    }

    // Reattach whenever another bundle is selected
    $(document).on(
        "click",
        ".washer_rack_bundle_selector .bundled-product",
        function () {

            setTimeout(attachObserver, 0);

        }
    );

    // Initial page load
    $(attachObserver);

})();
//FOR LAUNDRY GROUPSELL ADDON SELECTORS
$(document).on(
  "click",
  ".bundled-addon-selectors",
  function () {

    setTimeout(() => {

      if (typeof updateDynamicPrice === "function") {
        updateDynamicPrice();
      }

    }, 0);

  }
);

// =========================
// FAN QUANTITY
// update and add updateFanQtyPrice in global-scripts
// =========================
$(document).on(
  "click",
  ".cartQtyBox .qtyBtn",
  function () {

    // wait for the quantity script to update #aura-qty
    setTimeout(() => {

      if (typeof updateDynamicPrice === "function") {
        updateDynamicPrice();
      }

    }, 0);

  }
);




delayFix(() => $(".oasis-form .item, .variant-select .item").click(updateDynamicPrice));
delayFix(() => $(".ap-filter-sub-box-wrap .selector-month, .ap-filter-sub-box-wrap .selector-variant").on("change", updateDynamicPrice));
delayFix(() => $(`.accs-sel-wrapper input, [name="variant_id"]`).on("change", updateDynamicPrice));


// backup plan. do not turn these on unless emergency.
// const myInterval = setInterval(updateDynamicPrice, 1000);
// window.stopDynamicPrice = () => clearInterval(myInterval);


/* ===================================================
dropdown selection - default dropdown display 
====================================================== 
function updateCurrentSelectionFromOption($option) {

    const $current = $("#currentSelection");

    $current.attr({
        "data-variant": $option.val(),
        "data-price": $option.attr("data-price")?.replace(/,/g, ""),
        "data-compare": $option.attr("data-compare-price")?.replace(/[$,]/g, ""),
        "data-voucher": $option.attr("data-variantVoucher"),
        "data-stockNum": $option.attr("data-stockIndicatorNum"),
        "data-variant-timer": $option.attr("data-timer-value"),
        "data-bundled-variant-ids": $option.attr("data-bundled-variant-ids"),
        "data-restock": $option.attr("data-restock"),
        "data-atc": $option.attr("data-atc")
    });

    $("a#initateCheckout").text($option.attr("data-atc"));
}
function refreshCurrentSelection() {

    updateLinks();
    updateThumbnail();
    updateDeliveryTimer();
    updateStockIndicator();

    updateDynamicPrice();
}
$(document).on("change", ".product-form__variants2", function () {

    const $option = $(this).find("option:selected");

    updateCurrentSelectionFromOption($option);

    refreshCurrentSelection();

});

*/